import { FormType } from '../../../common/enums/sharedEnums';

interface FormTypeText {
  success: string;
  error: string;
}

export const formTypeText: Record<FormType, FormTypeText> = {
  [FormType.CREATE]: {
    success: 'Nouvelle commande enregistrée',
    error:
      "La nouveau commande n'est pas enregistrée, veuillez corriger les erreurs du formulaire ou contacter un administrateur"
  },
  [FormType.UPDATE]: {
    success: 'La modification de la commande a été enregistrée',
    error:
      "La modification de la commande n'est pas enregistrée, veuillez corriger les erreurs du formulaire ou contacter un administrateur"
  }
};
